import { gql } from '@apollo/client';

export const CLAIM_FIELDS = gql`
  fragment ClaimFields on Claim {
    title
    value
  }
`;
